import { get } from 'lodash';

import { FIELD_PATHS, YES_NO_OPTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { RadioButtonsField } from '../../../Fields';

export const IsOnlyPersonPresent = ({ brokerInterviewsGuarantorIndex }: BrokerInterviewsGuarantorEntityIndex) => {
  const [formValues] = useFormValues();

  return (
    <FunnelGrid mt="md" mb="md">
      <FunnelGridUnit size={1 / 2}>
        Is the guarantor the only person present at the interview, other than yourself? No borrowers or co-guarantors
        can be present during the interview.
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <RadioButtonsField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_IS_ONLY_PERSON_PRESENT(brokerInterviewsGuarantorIndex)}
          radios={YES_NO_OPTIONS}
          size="sm"
          isBoxed={false}
          noVerticalSpace
          selectedValue={get(
            formValues,
            FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_IS_ONLY_PERSON_PRESENT(brokerInterviewsGuarantorIndex)
          )}
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
